import Induk from './Induk'

export default Induk